<div class="wrapper">
  <div class="loginCard" align="center">
    <mat-card style="padding: 30px">
      <form [formGroup]="loginForm">
        <div class="row">
          <div class="col-12">
            <img src="assets/logoRegister.png" class="imgLogo" />
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label style="font-size: 17px">Usuário</mat-label>
              <input
                matInput
                type="text"
                placeholder="E-mail ou CPF"
                formControlName="user"
                required
              />
            </mat-form-field>
          </div>

          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>Senha</mat-label>
              <div class="d-flex flex-row justify-content-between">
                <input
                  matInput
                  [type]="hidePassword ? 'password' : 'text'"
                  formControlName="password"
                  required
                />
                <button
                  mat-icon-button
                  matSuffix
                  class="show-password-btn"
                  (click)="hidePassword = !hidePassword"
                  aria-label="Visualizar ou esconder senha"
                >
                  <fa-icon
                    [icon]="hidePassword ? 'eye-slash' : 'eye'"
                  ></fa-icon>
                </button>
              </div>
            </mat-form-field>
          </div>

          <div class="col-12" align="right">
            <a
              [routerLink]="['..', 'forgot-password']"
              style="font-weight: bold; text-decoration: none; font-size: 16px"
              class="blue"
              ><u>Esqueci minha senha</u></a
            >
          </div>

          <div class="col-12" *ngIf="enableIdpLogin">
            <div
              class="idp-login-panel"
              [class.idp-login-panel--active]="useIdp"
              role="region"
              aria-label="Opção de login corporativo Keycloak"
            >
              <div class="idp-login-panel__header">
                <span class="idp-login-panel__badge">IDP</span>
                <span class="idp-login-panel__title">Login corporativo</span>
              </div>
              <p class="idp-login-panel__hint">
                Use suas credenciais do <strong>Keycloak</strong> (mesmo e-mail cadastrado na
                Previdas). Desative para o login tradicional da plataforma.
              </p>
              <div class="idp-login-panel__toggle-row">
                <mat-slide-toggle
                  [(ngModel)]="useIdp"
                  [ngModelOptions]="{ standalone: true }"
                  color="primary"
                  class="idp-login-panel__toggle"
                >
                  Entrar com Keycloak
                </mat-slide-toggle>
                <span class="idp-login-panel__state" [class.idp-login-panel__state--on]="useIdp">
                  {{ useIdp ? 'Ativado' : 'Desativado' }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-12 p-margin-top-3 actions">
            <button
              mat-button
              class="btn-secondary btn-large"
              (click)="login()"
              [disabled]="isLoading"
            >
              <span *ngIf="!isLoading; else loadingLogin"> Entrar </span>

              <ng-template #loadingLogin>
                <mat-spinner [diameter]="30" color="primary"> </mat-spinner>
              </ng-template>
            </button>

            <!-- <a
              mat-button
              class="btn-large"
              [routerLink]="['/', 'public', 'account', 'register']"
            >
              Criar Conta
            </a> -->
          </div>
        </div>
      </form>
    </mat-card>
  </div>
</div>
